import { render, staticRenderFns } from "./SectionQuestion.vue?vue&type=template&id=fd69c93e&scoped=true"
import script from "./SectionQuestion.vue?vue&type=script&lang=js"
export * from "./SectionQuestion.vue?vue&type=script&lang=js"
import style0 from "./SectionQuestion.vue?vue&type=style&index=0&id=fd69c93e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd69c93e",
  null
  
)

export default component.exports